import { PopUpMessageContext } from '@hb/react'
import { AppName } from '@hb/shared'
import { useCallback, useContext } from 'react'
import { placeBillingHold } from '../../../backend/functions/other'
import { BillingHoldReasonModal } from '../../BillingHoldReasonModal'

interface BillingHoldModalProps {
  isOpen: boolean
  onClose: () => void
  visitId: string
  practiceId: string
  appName: AppName
}

export const BillingHoldModal = ({
  isOpen,
  onClose,
  visitId,
  practiceId,
  appName,
}: BillingHoldModalProps) => {
  const { processResponse } = useContext(PopUpMessageContext)

  const handleSubmit = useCallback(
    async (reason: string) => {
      await placeBillingHold({ visitId, practiceId, appName, action: 'place', reason })
      processResponse({ success: 'Billing hold placed' })
    },
    [visitId, practiceId, appName, processResponse],
  )

  return (
    <BillingHoldReasonModal
      isOpen={isOpen}
      onClose={onClose}
      header="Hold from billing"
      title="Hold from billing"
      description="This visit will be moved to the Provider Hold queue. Only you can release this hold."
      reasonLabel="Reason"
      reasonPlaceholder="Enter reason for billing hold"
      reasonRequired
      confirmLabel="Place hold"
      errorMessage="Failed to place billing hold"
      onSubmit={handleSubmit}
    />
  )
}
